import { useMemo } from 'react';
import type { PageItem } from '../utils/flattenEpisodesToPages';

export interface PageIndexProgressState {
  progressPercent: number;
  currentEpisodeNumber: number;
  canScrollLeft: boolean;
  canScrollRight: boolean;
}

interface UsePageIndexProgressParams {
  currentIndex: number;
  pages: PageItem[];
  episodes: { sceneEpisodeId?: string }[];
}

export const usePageIndexProgress = ({
  currentIndex,
  pages,
  episodes
}: UsePageIndexProgressParams): PageIndexProgressState => {
  return useMemo(() => {
    const totalPages = pages.length;
    const clampedIndex = Math.min(Math.max(0, currentIndex), Math.max(0, totalPages - 1));

    let progressPercent =
      totalPages > 0 ? Math.min(100, Math.round((clampedIndex / totalPages) * 100)) : 0;

    if (clampedIndex + 1 === totalPages) {
      progressPercent = 100;
    }

    let currentEpisodeNumber = 1;
    const currentEpisodeId = pages[clampedIndex]?.episode.sceneEpisodeId;
    if (currentEpisodeId) {
      const idx = episodes.findIndex((ep) => ep.sceneEpisodeId === currentEpisodeId);
      if (idx >= 0) currentEpisodeNumber = idx + 1;
    }

    return {
      progressPercent,
      currentEpisodeNumber,
      canScrollLeft: clampedIndex > 0,
      canScrollRight: clampedIndex < totalPages - 1
    };
  }, [currentIndex, pages, episodes]);
};
